var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.inactiveText')}},[_c('el-input',{model:{value:(_vm.optionModel.inactiveText),callback:function ($$v) {_vm.$set(_vm.optionModel, "inactiveText", $$v)},expression:"optionModel.inactiveText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }